import {
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import React, { useCallback, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Seat } from "../../interfaces";
import { beachSelectors } from "../../redux";
import BeachSelectorControls from "../BeachSelectorControls";
import BeachSelectorDialog from "../BeachSelectorDialog";

function fillArrayOfProgressiveNumber(number: number) {
  return new Array(number).fill(1).map((value, index) => index + value);
}

interface BeachSelectorProps {
  seats: Seat[];
  rows: number;
  beachId: string;
  seatsPerRow: number;
  maxPeople: number;
}

const useStyles = makeStyles({
  table: {
    minWidth: 650,
    maxWidth: "100%",
  },

  container: {
    maxHeight: 500,
  },
  cell: {
    minWidth: 100,
  },
});

const BeachSelector: React.FC<BeachSelectorProps> = ({
  seatsPerRow,
  rows,
  seats,
  beachId,
  maxPeople,
}) => {
  const classes = useStyles();
  const getSeatIdByMatrix = useSelector(beachSelectors.getSeatIdByMatrix);
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [selectedSeat, setSelectedSeat] = useState<{
    progressiveNumber: number;
    row: number;
  }>();

  const tableColumns = useMemo(
    () => fillArrayOfProgressiveNumber(seatsPerRow),
    [seatsPerRow]
  );
  const tableRows = useMemo(() => fillArrayOfProgressiveNumber(rows), [rows]);

  const checkIsReserved = useCallback(
    (row: number, column: number) => {
      const x = seats.find(
        (f) => f.row === row && f.progressiveNumber === column
      );
      return x;
    },
    [seats]
  );

  return (
    <>
      <TableContainer className={classes.container} component={Paper}>
        <Table
          stickyHeader
          className={classes.table}
          aria-label="caption table"
        >
          <caption>Ogni ombrellone corrisponde ad un posto</caption>
          <TableHead>
            <TableRow>
              <TableCell></TableCell>
              {tableColumns.map((column) => (
                <TableCell key={"column-" + column} className={classes.cell}>
                  Posto {column}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {tableRows.map((row) => (
              <TableRow key={"row-" + row}>
                <TableCell className={classes.cell} component="th" scope="row">
                  Fila {row}
                </TableCell>
                {tableColumns.map((cell) => (
                  <TableCell key={"cell-" + cell} component="th" scope="row">
                    <BeachSelectorControls
                      seatBookedNum={getSeatIdByMatrix(cell, row)?.maxPeople}
                      setSelectedSeat={() => {
                        row &&
                          setSelectedSeat({ row, progressiveNumber: cell });
                        setIsDialogOpen(true);
                      }}
                      isReserved={!!checkIsReserved(row, cell)}
                    ></BeachSelectorControls>
                  </TableCell>
                ))}
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <BeachSelectorDialog
        beachId={beachId}
        selectedSeat={selectedSeat}
        isOpen={isDialogOpen}
        onClose={() => {
          setIsDialogOpen(false);
        }}
        maxPeople={maxPeople}
      ></BeachSelectorDialog>
    </>
  );
};

export default BeachSelector;
